import React from "react";
import { observer } from "mobx-react";
import AddCreditCardPage from "~/modules/BillingCentral/app/AddCreditCardPage";
import "../styles/SidePage.less";

const ClientPanelAddCreditCardPage = observer(props => <AddCreditCardPage {...props} />);

export default ClientPanelAddCreditCardPage;
